export const calculateDayDifference = (first: string, second: string): number => {
  if (!first || !second) return null;

  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = +new Date(first);
  const secondDate = +new Date(second);

  return Math.ceil((firstDate - secondDate) / oneDay);
};
